export enum TicketType {
  DeleteCustomer = 'delete-customer'
}
